<template>
  <div id="ticket-form" class="container" v-bind:class="{ 'wrapper': current_step <= 2 }">
    <input type="hidden" name="eccId" v-model="ticket.eccId" />
    <h2 v-if="current_step == 0">{{ $t('wizard.richiedi_assistenza') }}</h2>
    <h2 v-else-if="current_step == 1">{{ $t('wizard.info_prodotto') }}</h2>
    <h2 v-else-if="current_step == 2 && (isProfilePrivato() || isProfileAzienda())">{{ $t('wizard.dati_cliente') }}</h2>
    <h2 v-else-if="current_step == 2 && !isProfilePrivato() && !isProfileAzienda()">{{ $t('wizard.info_contatto') }}
    </h2>


    <h3 v-if="current_step == 0">{{ $t('step1.subtitle') }}</h3>
    <h3 v-else-if="current_step == 1">{{ $t('step2.subtitle') }}</h3>
    <h3 v-else-if="current_step == 2 && !isProfilePrivato() && !isProfileAzienda()">{{ $t('step3.subtitle') }}</h3>


    <div class="wizard">
      <div class="wizard-header wizard-header-3" v-if="current_step <= 2">
        <div @click="if (this.current_step > 0) this.current_step = 0; this.postMessageIframe();"
          v-bind:class="{ active: current_step === 0, done: current_step > 0 }">
          <span>1</span>
          <div class="hr"></div>
        </div>
        <div @click="if (this.current_step > 1) this.current_step = 1; this.postMessageIframe();"
          v-bind:class="{ active: current_step === 1, done: current_step > 1 }">
          <span>2</span>
          <div class="hr"></div>
        </div>
        <div v-bind:class="{ active: current_step === 2 }">
          <span>3</span>
          <div class="hr"></div>
        </div>
      </div>

      <div class="row justify-content-center" v-bind:class="{ 'wizard-form': current_step <= 2 }">

        <div class="row" v-if="current_step == 0">
          <div class="col-12">
            <div class="wrapper-fields">
              <div class="wrapper-input select" v-bind:class="{ error: errors.customer_profile_type }">
                <select required v-model="ticket.customer.profile_type"
                  @change="onClearError({ key: 'customer_profile_type', value: !!$event.target.value })">
                  <option disabled selected value="" hidden>{{ $t('step1.select_profile') }} <span
                      class="ic-require">*</span></option>
                  <option v-for="item in profile_types" :key="item.value" v-bind:value="item.value"
                    v-text="$t(item.label)"></option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="current_step == 1">

          <div class="col-12">
            <div class="wrapper-fields">
              <div class="wrapper-input select" v-bind:class="{ error: errors.family }">
                <select required v-model="ticket.family"
                  @change="onClearError({ key: 'family', value: !!$event.target.value })">
                  <option disabled selected value="" hidden>{{ $t('step2.select_family') }} <span
                      class="ic-require">*</span></option>
                  <option v-for="item in families" :key="item.value" v-bind:value="item.value" v-text="$t(item.label)">
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="wrapper-fields">
              <div class="wrapper-input select" v-bind:class="{ error: errors.product }">
                <select required v-model="ticket.product"
                  @change="onClearError({ key: 'product', value: !!$event.target.value })">
                  <option disabled selected value="" hidden>{{ $t('step2.select_product') }} <span
                      class="ic-require">*</span></option>
                  <option v-for="item in getProductsForFamily()" :key="item.value" v-bind:value="item.value"
                    v-text="$t(item.label)">
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="col-12" v-if="hasChooseADoor()">
            <div class="wrapper-fields">
              <div class="wrapper-input select" v-bind:class="{ error: errors.product_with_door }">
                <select required v-model="ticket.product_with_door"
                  @change="onClearError({ key: 'product_with_door', value: !!$event.target.value })">
                  <option disabled selected value="" hidden>{{ $t('step2.select_product_with_door') }}
                    <span class="ic-require">*</span>
                  </option>
                  <option v-for="item in getProductsInAdditionToDoor()" :key="item.value" v-bind:value="item.value"
                    v-text="$t(item.label)">
                  </option>
                </select>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="wrapper-fields">
              <div class="d-flex flex-lg-row flex-column">
                <div class="col-12 col-lg-8 wrapper-input" v-bind:class="{ error: errors.num_matricola }">
                  <input type="text" v-model="ticket.num_matricola"
                    :placeholder="$t('step2.num_matricola') + '*'"
                    @input="onClearError({ key: 'num_matricola', value: !!$event.target.value })" />
                </div>
                <div class="col-0 col-lg-1"></div>
                <div v-if="getImgProduct() != null" class="col-12 col-lg-3 mt-lg-0 mt-2">
                  <button type="button" :disabled="!ticket.product"
                    class="btn-tooltip btn-outline-primary text-uppercase" data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop">
                    {{ $t('step2.num_matricola_dove_si_trova') + " ?" }}
                  </button>
                </div>
              </div>
            </div>
          </div>


          <div class="col-12">
            <div class="wrapper-fields">
              <div class="wrapper-input-radio" v-bind:class="{ error: errors.dc_infunzione }">
                <p>{{ $t('step2.question_volte_utilizzo_prodotto') + '*' }}</p>
                <div class="radio-wrapper" v-for="item in options_volte_utilizzo_prodotto" :key="item.id">
                  <input type="radio" v-bind:id="item.id" v-bind:value="item.id" v-model="ticket.dc_infunzione"
                    @change="onClearError({ key: 'dc_infunzione', value: true })">
                  <label v-bind:for="item.id">{{ item.name }}</label>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="wrapper-fields">
              <div class="wrapper-input textarea" v-bind:class="{ error: errors.descrizione_problema }">
                <textarea type="text" v-model="ticket.descrizione_problema"
                  :placeholder="$t('step2.descrizione_prodotto') + '*'"
                  @input="onClearError({ key: 'descrizione_problema', value: !!$event.target.value })" />
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="wrapper-fields">
              <div class="wrapper-input-file" v-bind:class="{ error: errors.file }">
                <p>{{ requiresInvoice() ? $t('step2.allega_file_obbligatorio')+" *" : $t('step2.allega_file') }}</p>
                <div class="d-flex align-items-center">
                  <label for="file-upload" class="custom-file-upload">
                    <span v-if="!fileUploading">{{ $t('step2.scegli_file') }}</span>
                    <div v-else class="loader"></div>
                  </label>
                  <input :required="requiresInvoice()" id="file-upload" type="file" @change="previewFile"
                    accept="video/mp4,video/x-m4v,video/*,image/*,.pdf,.heic" />
                  <!-- <span class="file-uploaded">{{ listFileNameUploaded }}</span> -->
                </div>
                <div class="mt-4">
                  <ul class="px-0">
                    <li class="file-uploaded d-flex align-items-center mb-3"
                      v-for="(item, index) in listFileNameUploaded" :key="index">
                      <span class="d-block">{{ item }}</span>
                      <button class="mx-2 border-0 bg-transparent p-0" @click="removeFileAtIndex(index)"><img
                          style="width: 20px;height: 20px;" :src="getRemoveFileIcon()" /></button>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="modal fade" id="staticBackdrop" tabindex="-1" aria-labelledby="staticBackdropLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
              <div class="modal-content">
                <button class="icon-close" data-bs-toggle="modal" data-bs-target="#staticBackdrop">
                  <img v-bind:src="iconCloseModal">
                </button>
                <div class="modal-body">
                  <div v-if="getImgProduct() != null">
                    <p class="title-product">
                      {{ $t('step2.modal_title') }}
                    </p>
                    <div class="separator"></div>
                    <p class="subtitle-product">
                      {{ $t('step2.modal_subtitle') }}
                    </p>
                    <img v-bind:src="getImgProduct()" class="img-product">
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <div class="row" v-if="current_step == 2">
          <div v-if="!isProfileAzienda() && !isProfilePrivato()">
            <div class="wrapper-content-profile" style="margin-bottom:50px;">
              <h2>{{ $t('step3.tuoi_dati') }}</h2>
              <h3>{{ $t('step3.fornisci_recapito') }}</h3>
            </div>

            <div class="wrapper-fields">
              <contact-form v-model="ticket.contact" :errors="errors" @onClearError="onClearError"
                :companyRequired="true" :companyVisible="true" />
            </div>

            <div style="margin:50px 0;" class="wrapper-content-profile">
              <h2>{{ $t('step3.dati_cliente') }}</h2>
              <h3>{{ $t('step3.inscerisci_info_cliente') }}</h3>
            </div>

            <div class="wrapper-fields">
              <customer-form v-model="ticket.customer" @onClearError="onClearError" :errors="errors" />
            </div>
          </div>
          <div v-else>
            <div class="wrapper-fields">
              <customer-form v-model="ticket.customer" :companyRequired="!isProfilePrivato()"
                :companyVisible="!isProfilePrivato()" :errors="errors" @onClearError="onClearError" />
            </div>

            <div class="col-12" style="margin:57px 0 40px 0;">
              <div class="wrapper-fields">
                <div class="wrapper-input-radio">
                  <p v-if="isProfilePrivato()">{{ $t('step3.contatto_differente') }}</p>
                  <p v-else-if="isProfileAzienda()">{{ $t('step3.assistenza_contatto_differente') }}</p>
                  <div class="radio-wrapper" v-for="item in extra_contact_choices" :key="item.id">
                    <input type="radio" v-bind:id="item.id" v-bind:value="item.id" v-model="ticket.extra_contact"
                      @change="postMessageIframe()">
                    <label v-bind:for="item.id">{{ item.name }}</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="wrapper-fields" v-if="ticket.extra_contact == 'si'">
              <contact-form v-model="ticket.contact" :errors="errors" @onClearError="onClearError" />
            </div>
          </div>

          <div class="wrapper-fields">
            <div class="col-12" style="margin-top:60px;">
              <div class="wrapper-input-checkbox" v-bind:class="{ error: errors.privacy }">
                <input type="checkbox" id="privacy" v-bind:checked="ticket.privacy" v-model="ticket.privacy"
                  @change="onClearError({ key: 'privacy', value: !!$event.target.value })">
                <label for="privacy">
                  <a href="https://www.effe.it/privacy-policy/" target="_blank"><span>{{ $t('step3.privacy.part1')
                      }}</span>
                  </a>
                </label>
              </div>
            </div>
          </div>

        </div>

        <div class="wrapper-msg"
          v-bind:class="{ error: !ticketIsCreatedSuccessfully, success: ticketIsCreatedSuccessfully }"
          v-if="current_step == 3">
          <div class="vline"></div>
          <h2 class="final-msg">
            {{ this.ticketIsCreatedSuccessfully ? $t('final_msg_success') : $t('final_msg_error') }}
          </h2>
          <!-- <p class="text-center mt-4 closing_summer" v-html="$t('closing_summer')"></p> -->
          <button v-if="!ticketIsCreatedSuccessfully" class="icon-back" @click="this.current_step = 2">
            <img v-bind:src="iconBackBtn">
          </button>
          <div class="vline"></div>
        </div>
      </div>

      <div class="wizard-actions" v-if="current_step <= 2">
        <button v-if="current_step <= 1 || (current_step == 2 && !fileUploading && !needWaitingToSubmitTicket)"
          type="button" class="btn btn-outline-primary text-uppercase" @click="submit">{{ current_step != 2 ?
            $t('wizard.procedi') : $t('wizard.invia_richiesta') }}</button>
        <div v-else class="loader"></div>
      </div>

    </div>
  </div>
</template>

<script>

import ListProfileTypes, { AZIENDA, PRIVATO } from '../consts/listProfileTypes'
import ListProductTypes from '../consts/listProducts'
import { it } from "date-fns/locale";
import ContactForm from "./../components/ContactForm.vue"
import CustomerForm from "./../components/CustomerForm.vue"
import iconCloseModal from "./../assets/img/close-icon.png"
import iconBackBtn from "./../assets/img/btn_back.png"
import ListFamilies, { FAMILY_PORTE } from '../consts/listFamilies'
import ticketMixin from "@/mixins/ticketMixin";
import moment from "moment";
import TicketController from "@/controllers/TicketController"
import { DEFAULT_PHONE_PREFIX, withFullPhone } from "@/utils/phone"

function isInverseThemeEnabled() {
  const inverseParam = new URLSearchParams(window?.location?.search).get('inverse');
  return inverseParam === 'true' || inverseParam === '1';
}

function getEccIdFromQuery() {
  return new URLSearchParams(window?.location?.search).get('eccId') || "";
}

function getTicketChannelFromQuery() {
  return new URLSearchParams(window?.location?.search).get('ticket_channel') || "Website";
}

function initialErrorState() {
  return {
    customer_profile_type: false,
    family: false,
    product: false,
    product_with_door: false,
    descrizione_problema: false,
    dc_infunzione: false,
    num_matricola: false,
    file: false,
    privacy: false,
    //contact
    contact_nome: false,
    contact_cognome: false,
    contact_email: false,
    contact_tel: false,
    contact_azienda: false,
    contact_indirizzo: false,
    contact_paese: false,
    contact_cap: false,
    contact_provincia: false,
    //customer
    customer_nome: false,
    customer_cognome: false,
    customer_azienda: false,
    customer_email: false,
    customer_tel: false,
    customer_indirizzo: false,
    customer_paese: false,
    customer_cap: false,
    customer_provincia: false
  }
}

export default {
  name: 'RichiediAssistenza',
  mixins: [ticketMixin],
  data() {
    return {
      ticket: {
        eccId: getEccIdFromQuery(),
        ticket_channel: getTicketChannelFromQuery(),
        family: "",
        product: "",
        product_with_door: "",
        dc_infunzione: "",
        extra_contact: "no",
        num_matricola: "",
        // info matricola
        m_codice_articolo: "",
        m_descrizione: "",
        m_sotto_classe: "",
        m_rivenditore: "",
        m_riferimento_ddt: "",
        m_data_ddt: "",
        m_linea_prodotto: "",
        m_tipologia_prodotto: "",
        descrizione_problema: "",
        contact: {
          profile_type: "",
          name: "",
          surname: "",
          company: "",
          email: "",
          telephonePrefix: DEFAULT_PHONE_PREFIX,
          telephone: "",
          address: "",
          country: "Italia",
          hs_country_region_code: "IT",
          cap: "",
          province: "",
        },
        customer: {
          profile_type: "",
          name: "",
          surname: "",
          company: "",
          email: "",
          telephonePrefix: DEFAULT_PHONE_PREFIX,
          telephone: "",
          address: "",
          country: "Italia",
          hs_country_region_code: "IT",
          cap: "",
          province: "",
        },
        privacy: false,
        // files
        uploadTokens: [],
        uploadTokensV2: [],
      },
      locale: it,
      errors: initialErrorState(),
      listFileNameUploaded: [],
      fileUploading: false,
      current_step: 0,
      confirmation_step: 3,
      profile_types: ListProfileTypes,
      families: ListFamilies,
      product_types: ListProductTypes?.sort((a, b) => String(this.$t(b.label)).toLowerCase() > String(this.$t(a.label)).toLowerCase() ? -1 : 1),
      options_volte_utilizzo_prodotto: [{ //TODO: da rivedere per Hubspot
        id: "never",
        name: this.$t('step2.question_garanzia_never')
      }, {
        id: "less_than_5",
        name: this.$t('step2.question_garanzia_less5')
      }, {
        id: "greater_than_5",
        name: this.$t('step2.question_garanzia_greater5')
      }],
      extra_contact_choices: [{
        id: "no",
        name: this.$t('general.no')
      }, {
        id: "si",
        name: this.$t('general.si')
      }],
      iconCloseModal,
      iconBackBtn,
      needWaitingToSubmitTicket: false,
      ticketIsCreatedSuccessfully: false
    }
  },
  mounted: function () {
    this.postMessageIframe()
  },
  methods: {
    getRemoveFileIcon() {
      return isInverseThemeEnabled() ? 'images/closeicon_black.png' : 'images/closeicon.png';
    },
    async submit() {
      const format_date = "yyyy-MM-DD"
      const validateEmail = (email) => {
        return !!String(email)
          .toLowerCase()
          .match(
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          );
      };

      if (this.current_step === 2) {
        let _error = false;
        if (!this.ticket.privacy) { this.errors.privacy = true; _error = true; }
        if ((!this.isProfileAzienda() && !this.isProfilePrivato()) || ((this.isProfileAzienda() || this.isProfilePrivato()) && this.ticket.extra_contact === 'si')) {
          if (!this.ticket.contact.name) { this.errors.contact_nome = true; _error = true; }
          if (!this.ticket.contact.surname) { this.errors.contact_cognome = true; _error = true; }
          if (!this.ticket.contact.email || !validateEmail(this.ticket.contact.email)) { this.errors.contact_email = true; _error = true; }
          if (!this.ticket.contact.telephone) { this.errors.contact_tel = true; _error = true; }
          if (!this.isProfileAzienda() && !this.isProfilePrivato() && !this.ticket.contact.company) { this.errors.contact_azienda = true; _error = true; }
          if (!this.ticket.contact.address) { this.errors.contact_indirizzo = true; _error = true; }
          if (!this.ticket.contact.country) { this.errors.contact_paese = true; _error = true; }
          if (!this.ticket.contact.cap) { this.errors.contact_cap = true; _error = true; }
          if (!this.ticket.contact.province) { this.errors.contact_provincia = true; _error = true; }
        }
        if (!this.ticket.customer.name) { this.errors.customer_nome = true; _error = true; }
        if (!this.ticket.customer.surname) { this.errors.customer_cognome = true; _error = true; }
        if (!this.ticket.customer.company && this.isProfileAzienda()) { this.errors.customer_azienda = true; _error = true; }
        if (!this.ticket.customer.email || !validateEmail(this.ticket.customer.email)) { this.errors.customer_email = true; _error = true; }
        if (!this.ticket.customer.telephone) { this.errors.customer_tel = true; _error = true; }
        if (!this.ticket.customer.address) { this.errors.customer_indirizzo = true; _error = true; }
        if (!this.ticket.customer.country) { this.errors.customer_paese = true; _error = true; }
        if (!this.ticket.customer.cap) { this.errors.customer_cap = true; _error = true; }
        if (!this.ticket.customer.province) { this.errors.customer_provincia = true; _error = true; }

        if (_error) { return; }

        try {
          this.needWaitingToSubmitTicket = true;
          const payload = {
            ...this.ticket,
            locale: this.getLocale(),
            customer: {
              ...withFullPhone(this.ticket.customer),
              profile_type: this.ticket.customer.profile_type === AZIENDA ? AZIENDA : PRIVATO,
              country: this.ticket?.customer?.country
            },
            contact: {
              ...withFullPhone(this.ticket.contact),
              profile_type: this.ticket.customer.profile_type === AZIENDA ? PRIVATO : this.ticket.customer.profile_type
            },
            data_ddt_vendita: this.ticket.m_data_ddt ? (moment(this.ticket.m_data_ddt, "DD/MM/yyyy").isValid() ? moment(this.ticket.m_data_ddt, "DD/MM/yyyy").format(format_date) : "") : "",
            data_today: moment().format(format_date),
            datetime_today: moment().valueOf()
          }
          const res = await TicketController.newTicket(payload);
          this.needWaitingToSubmitTicket = false;
          if (res?.status === 200) {
            this.ticketIsCreatedSuccessfully = true;
            if (this.$gtm.enabled()) {
              window?.dataLayer?.push({
                event: 'cf7mailInviata',
                cf7FormId: 'richiesta_assistenza',
              });
              console.log(`gtm cf7mailInviata`)
            }
          } else {
            this.ticketIsCreatedSuccessfully = false;
          }
        } catch (error) {
          this.needWaitingToSubmitTicket = false;
          this.ticketIsCreatedSuccessfully = false;
        }
      } else if (this.current_step == 0) {
        if (!this.ticket.customer.profile_type) {
          this.errors.customer_profile_type = true;
          return;
        }
      } else if (this.current_step == 1) {
        let _error = false;
        if (!this.ticket.family) { this.errors.family = true; _error = true; }
        if (!this.ticket.product) { this.errors.product = true; _error = true; }
        if (this.ticket.family === FAMILY_PORTE && !this.ticket.product_with_door) { this.errors.product_with_door = true; _error = true; }
        if (!this.ticket.num_matricola) { this.errors.num_matricola = true; _error = true; }
        if (!this.ticket.dc_infunzione) { this.errors.dc_infunzione = true; _error = true; }
        if (!this.ticket.descrizione_problema) { this.errors.descrizione_problema = true; _error = true; }
        if (!this.listFileNameUploaded?.length && this.requiresInvoice()) { this.errors.file = true; _error = true; }
        if (_error) { return; }
      }
      initialErrorState();
      this.current_step += 1;
      window.scrollTo(0, 0);
      this.postMessageIframe()
    }
  },
  components: { ContactForm, CustomerForm },
}
</script>
